import React from "react";
import "./FixedDetails.css";
import dayjs from "dayjs";
import { Alert, Col, Row } from "antd";
import moment from "moment";
import useLocalTime from "../../hooks/useLocalTime";
import img1 from "../../img/1.svg"
import img2 from "../../img/2.svg"
import img3 from "../../img/3.svg"
import img4 from "../../img/4.svg"
const FixedDetails2 = ({ orderData }) => {
  const formatDate = (date) => {
    return moment(date).local().format("DD MMM YYYY,hh:mm A");
  };

  const parseDate = (dateStr) => {
    return dayjs(
      dateStr,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    ); // Add other formats as needed
  };

  // const calculateDaysLeft = (start, end) => {
  //   const startDate = parseDate(start);
  //   const endDate = parseDate(end);
  // console.log(startDate , endDate)
  //   if (!startDate.isValid() || !endDate.isValid()) {
  //     console.error("Invalid dates:", start, end);
  //     return 0;
  //   }

  //   return endDate.diff(startDate, 'day'); // Calculate difference in days
  // };

  // const timeleft = calculateDaysLeft(
  //   orderData?.data?.start_date,
  //   orderData?.data?.deadline_hard
  // );

  // Get deadline info including both title and value
  const getDeadlineInfo = () => {
    const { deadline_hard, alloted_deadline } = orderData?.data || {};

    // If both deadlines exist, show alloted deadline
    if (deadline_hard && alloted_deadline) {
      return {
        title: "Client Deadline",
        value: formatDate(deadline_hard),
      };
    }

    // If only hard deadline exists, show it
    if (deadline_hard) {
      return {
        title: "Client Deadline",
        value: formatDate(deadline_hard),
      };
    }

    // If only alloted deadline exists, show it
    if (alloted_deadline) {
      return {
        title: "Alloted Deadline",
        value: formatDate(alloted_deadline),
      };
    }

    // If no deadline exists
    return {
      title: "Deadline",
      value: "No deadline set",
    };
  };

  const deadlineInfo = getDeadlineInfo();

  const data = {
    orderID: orderData?.data?.key,
    wordCount: orderData?.data?.writer_word_count,
    startDate: moment(orderData?.data?.start_date)
      .local()
      .format("DD MMM YYYY,hh:mm A"),
    deadline: deadlineInfo.value,

    // timeleft: `${timeleft} days`,
  };
  const cards = [
    {
      key: "orderID",
      title: "Order ID",
      value: data.orderID,
      image: img1,
    },
    {
      key: "wordCount",
      title: "Writer Word Count",
      value: data.wordCount,
      image: img2,
    },
    {
      key: "startDate",
      title: "Start Date",
      value: data.startDate,
      image: img3,
    },
    {
      key: "deadline",
      title: deadlineInfo.title, // Dynamic title based on deadline type
      value: data.deadline,
      image:
        img4,
    },
  ];

  if (orderData?.data?.feedback_deadline) {
    cards.push({
      key: "feedback_deadline",
      title: "Feedback Deadline",
      value: moment(orderData.data.feedback_deadline).local().format("DD MMM YYYY,hh:mm A"),
      image: img4, // date icon
    });
  }
  return (
    <div className="parentdiv">
  <div className="details-card-row">
    {cards.map(({ key, title, value, image }) => (
      <div  className="details-card" key={key}>
    
    <div style={{display:"flex",alignItems:"center",justifyContent:"center" , background:"#36c6d3" , width:'40px' , height:'40px' , borderRadius:'100%' , position:'absolute' , top:'10px' , right:'10px' }}>

<img  src={image} alt={title} style={{width:'30px' , height:'30px'}} />
</div>
        <div className="details-card-content">
          <div className="static_field">{title}</div>
          <div className="value">{value}</div>
        </div>
      </div>
    ))}
  </div>
</div>
  );
};

export default FixedDetails2;